module.exports = __webpack_public_path__ + "static/media/TOGF_110.f081fbe0.png";